/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type SellAllBciMutationVariables = Types.Exact<{
	input: Types.BciTradeSellAllRequest;
}>;

export type SellAllBciMutation = {
	__typename?: "Mutation";
	sellAllBci:
		| {
				__typename?: "BciTradeInProgressResponse";
				tradeInProgress: { __typename?: "BciTradeInProgress"; tradeId: string };
		  }
		| {
				__typename?: "BciTradeSuccessResponse";
				trade: {
					__typename?: "BciTrade";
					tradeId: string;
					wallet: { __typename?: "Wallet"; id: string };
					taxWithheld?: {
						__typename?: "Tax";
						isTaxServiceAvailable: boolean;
						fiatId: string;
						assetId?: string | null;
						taxAmountFiat: { __typename?: "CurrencyAmount"; value: string };
						fiatAmountAfterTax?: { __typename?: "CurrencyAmount"; value: string } | null;
						taxAmountAsset?: { __typename?: "CurrencyAmount"; value: string } | null;
					} | null;
				};
		  };
};

export const SellAllBciDocument = gql`
	mutation sellAllBci($input: BciTradeSellAllRequest!) {
		sellAllBci(request: $input) {
			... on BciTradeSuccessResponse {
				trade {
					tradeId
					wallet {
						id
					}
					taxWithheld {
						taxAmountFiat {
							value
						}
						isTaxServiceAvailable
						fiatId
						assetId
						fiatAmountAfterTax {
							value
						}
						taxAmountAsset {
							value
						}
					}
				}
			}
			... on BciTradeInProgressResponse {
				tradeInProgress {
					tradeId
				}
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class SellAllBciGQLService extends Apollo.Mutation<SellAllBciMutation, SellAllBciMutationVariables> {
	document = SellAllBciDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
